import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { SearchConfig } from "@/components/dynamic-form";
import { SearchBarType } from "@/components/dynamic-form/constants";
import {
  Channel,
  ModuleType,
  OperateSource,
} from "@/pages/operate-record/types";
import { getDateAfterDay } from "@/utils/date-formatter/getDateAfterDay";
import dayjs from "project-config/utils/dayjs";

export function getSearchConfig(): SearchConfig[] {
  const t = getTranslateNsT("operateRecord");
  const tt = getTranslateNsT("center");
  return [
    {
      type: SearchBarType.DatePicker,
      field: "time",
      label: tt("user_consume_pick_date"),
      props: {
        defaultValue: [
          dayjs(getDateAfterDay(new Date(), -1)),
          dayjs(getDateAfterDay(new Date(), 0)),
        ],
      },
    },
    {
      type: SearchBarType.Select,
      label: tt("user_operate_record_operate_origin"),
      field: "operateSource",
      props: {
        placeholder: tt("user_consume_pick_platform_all"),
        dropdownMatchSelectWidth: false,
        options: [
          {
            value: OperateSource.ALL,
            label: t("monitor_log_operate_origin_0"),
          },
          {
            value: OperateSource.Main,
            label: t("monitor_log_operate_origin_1"),
          },
          {
            value: OperateSource.Sub,
            label: t("monitor_log_operate_origin_2"),
          },
          {
            value: OperateSource.AuthAdmin,
            label: t("monitor_log_operate_origin_3"),
          },
          {
            value: OperateSource.DingSub,
            label: t("monitor_log_operate_origin_4"),
            isFoxHidden: true,
          },
        ],
      },
    },
    {
      type: SearchBarType.Select,
      label: t("user_operate_record_module_type"),
      field: "taskType",
      props: {
        placeholder: tt("custom_display_text_all"),
        dropdownMatchSelectWidth: false,
        options: [
          {
            value: ModuleType.All,
            label: t("user_operate_record_module_all"),
          },
          {
            value: ModuleType.Assets,
            label: t("user_operate_record_module_assets"),
          },
          {
            value: ModuleType.RenderingTask,
            label: t("user_operate_record_module_render"),
          },
          {
            value: ModuleType.AnalysisTask,
            label: t("user_operate_record_module_analysis"),
          },
          {
            value: ModuleType.UserInfo,
            label: t("user_operate_record_module_userInfo"),
          },
          {
            value: ModuleType.Project,
            label: t("user_operate_record_module_project"),
          },
          {
            value: ModuleType.UserAuth,
            label: t("user_operate_record_module_userAuth"),
          },
          {
            value: ModuleType.DingtalkSubUser,
            label: t("user_operate_record_module_dingtalkSubUser"),
            isPictureHidden: true,
          },
          {
            value: ModuleType.Setting,
            label: t("user_operate_record_module_setting"),
          },
          {
            value: ModuleType.CloudProduce,
            label: t("user_operate_record_module_cloudProduce"),
          },
        ],
      },
    },
    {
      type: SearchBarType.Input,
      label: tt("analysis_table_header_id"),
      hidden: true,
      field: "taskIds",
    },
    {
      type: SearchBarType.Select,
      label: tt("user_operate_record_user_name"),
      field: "userId",
      props: {
        placeholder: tt("user_consume_pick_platform_all"),
        allowClear: true,
        dropdownMatchSelectWidth: false,
        options: [{ label: tt("user_consume_pick_project_all"), value: 0 }],
      },
    },
    {
      type: SearchBarType.Select,
      label: tt("search_channel"),
      field: "channel",
      props: {
        placeholder: tt("user_consume_pick_platform_all"),
        dropdownMatchSelectWidth: false,
        options: [
          {
            value: Channel.ALL,
            label: t("monitor_log_channel_0"),
          },
          {
            value: Channel.Animation,
            label: t("monitor_log_channel_1"),
          },
          {
            value: Channel.Web,
            label: t("monitor_log_channel_2"),
          },
        ],
      },
    },
  ];
}
